import { createReducer, on } from "@ngrx/store";
import * as productsActions from './details-actions';
import * as fromProducts from './details-state';
import { ShippingTypeEnum } from "@app/marketplace/core/enum/shippingType";

const initialState: fromProducts.State = {
  isLoading:false,
  shippingType:ShippingTypeEnum.None,
  message:"",
  data:{},
  quantity:1,
  combination:"",
  attributes:[]
};
export const reducer = createReducer(
  initialState,
  on(productsActions.LoadingProductDetailAction, (state) => {
    return {...state,isLoading:true}
  }),
  on(productsActions.LoadingProductDetailDlgAction, (state,{code,provider}) => {
    return {...state,isLoading:true}
  }),
  on(productsActions.ProductDetailsAction, (state,{data}) => {
    state.attributes = [];
    data?.data?.productAttributes?.map(function (item) {
      state.attributes.push({attrId:item.id,attrText:item.text,valId:"",valText:""});
    });
    return {...state,isLoading:false,data}
  }),
  on(productsActions.SetShippingType, (state, {shippingType}) => {
    return {...state, shippingType};
  }),

  on(productsActions.SetActiveAttributeValue, (state, {attr,active}) => {
    var attrId=attr.attrId;var valId=attr.valId; var valText=attr.valText;
    if (!active) {
      state.data?.data?.productAttributes?.forEach(function (item) {
        if (item.id == attrId) {
          item.values.map(function (val) {
            /* if (val.active) val.active = !val.active;
            else  */
            val.active = val.id == valId;
          })
        }
      });
      state.attributes = state.attributes.map(function(value){
        if(value.attrId === attrId){
          value.valId=valId;
          value.valText=valText;
        } return value;
      })
      state.combination = state.attributes.map(o => o.valId).join('');
      checkAvailability(state,attrId,valId);
      let item=state.data?.data?.priceCombinations?.find(x => x.id === state.combination);
      if(item){
        state.data.data.price=item.price;
        state.data.data.discount=item.discount;
        state.data.data.priceToShow=item.priceToShow;
        state.data.data.oldPriceToShow=item.oldPriceToShow;
        state.data.data.availability=item.availability;
        state.data.data.availabilityToShow={
          value: item.availabilityToShow,
          color: "",
          style: 0
        };
      }
    }
    else{
      state.data?.data?.productAttributes?.forEach(function (item) {
        item.values.map(function (val) {
          val.active = false;
          val.disable = false;
        })
      });
      state.combination ="";
      state.attributes = state.attributes.map(function(value){
          value.valId="";
          value.valText="";
          return value;
      })
    }
    return {...state};
  }),

  on(productsActions.SetError, (state, {message}) => {
    return {...state, message};
  }),
  on(productsActions.ErrorProductDetailsActions, (state) => {
    return {...state, isLoading: false};
  }),
  on(productsActions.CancelProductDetailsRequestAction, (state) => {
    return {...state, isLoading: false};
  }),
  on(productsActions.IncreaseQuantityAction, (state) => {
    return {...state,quantity:state.quantity<10?state.quantity += 1:10};
  }),
  on(productsActions.ReduceQuantityAction, (state) => {
    return {...state,quantity:state.quantity==1?1:state.quantity -= 1};
  }),
  on(productsActions.ResetQuantityAction, (state) => {
    return {...state,quantity: 1};
  }),
);

function checkAvailability(state: fromProducts.State, attrId:string,valId: string) {
    let result= state.data?.data?.priceCombinations.filter((p) =>p.availability>0 && p.attributes.find((d) => d.id==valId)).flatMap(function (item) {
      return item.attributes.filter((p) => p.parent!=attrId).map((val)=>val)
    });
    state.data?.data?.productAttributes?.filter((p) => p.id!=attrId).forEach(function (item) {
      item.values.map(function (val) {
        val.disable = !result.find((d) => d.id==val.id);
      })
    });
}
